// Shared options for all workspace list and detail hook call-sites.
// refetchOnMountOrArgChange — guarantees fresh data every time the user navigates
//   between list ↔ detail (openCards toggles remount the component cleanly).
// refetchOnReconnect — catches "laptop was asleep" / "briefly offline" cases cheaply.
// NOT refetchOnFocus — too aggressive for a field-service app (alt-tab → API storm).
//
// House rule: every new RTK-Query-backed workspace module's primary list-hook and
// detail-hook call-sites MUST pass this constant. See WORKSPACE_REFRESH.md.
export const WORKSPACE_QUERY_OPTIONS = {
  refetchOnMountOrArgChange: true as boolean | number | undefined,
  refetchOnReconnect: true as boolean | undefined,
} as const;
